/*
  The rules behind the Customize / solve-settings panel, shared because both
  apps draw the same panel over the same filters and must not disagree about
  what a setting means. Only the markup is per-platform; the ordering, the
  club-only rule and the lane bookkeeping live here.
*/
/** What to reach for first. Each one reads the imported club. */
export const PRIORITISE_KEYS = [
    "prioritizeSbcStorage",
    "prioritizeDuplicates",
    "includeTransferlist",
];
/** Include or leave out a kind of player. The flag is the exclude. */
export const INCLUDE_EXCLUDE_KEYS = [
    "excludeSbcPlayers",
    "excludeObjectivePlayers",
    "excludeActiveSquad",
];
/*
  Settings that only mean something with a club to draw on. Turning one on
  while solving from the market alone moves the scope to My Club, through the
  same rules the scope control applies.
*/
export const CLUB_ONLY_KEYS = new Set([
    "useUntradeablesOnly",
    "prioritizeSbcStorage",
    "prioritizeDuplicates",
    "includeTransferlist",
    "excludeActiveSquad",
]);
export const RATING_MIN = 1;
export const RATING_MAX = 99;
/** The player search under the lanes, on both platforms. */
export const PLAYER_SEARCH = {
    minChars: 2,
    debounceMs: 250,
    maxResults: 12,
};
/** A player sits in exactly one lane, so adding to one removes from the other. */
export const addToLane = (settings, lane, player) => {
    const without = (list) => list.filter((p) => p.resourceId !== player.resourceId);
    return lane === "include"
        ? {
            ...settings,
            includedPlayers: [...without(settings.includedPlayers), player],
            excludedPlayers: without(settings.excludedPlayers),
        }
        : {
            ...settings,
            excludedPlayers: [...without(settings.excludedPlayers), player],
            includedPlayers: without(settings.includedPlayers),
        };
};
export const removeFromLane = (settings, lane, resourceId) => {
    const key = lane === "include" ? "includedPlayers" : "excludedPlayers";
    return {
        ...settings,
        [key]: settings[key].filter((p) => p.resourceId !== resourceId),
    };
};
/** A range typed the wrong way round is still a range. */
export const normaliseRatings = (settings) => {
    const { minRating, maxRating } = settings;
    if (minRating !== null && maxRating !== null && minRating > maxRating) {
        return { ...settings, minRating: maxRating, maxRating: minRating };
    }
    return settings;
};
//# sourceMappingURL=solveSettings.js.map